import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import RequirementTemplateBlueprintType from '../../../../types/RequirementTemplateBlueprintType';

import RequirementTemplateBuilderBodyRight from './components/RequirementTemplateBuilderBodyRight';
import RequirementTemplateBuilderHeaderRight from './components/RequirementTemplateBuilderHeaderRight';

const RequirementTemplateRightBox = ({ blueprint }) => {
  const showSideHeaders = useSelector(blueprint.selectShowSideHeaders);
  return (
    <Flex
      direction="column"
      h="100%"
      justifyContent="space-between"
      minH="75vh"
      minW="380px"
      w="380px"
    >
      {showSideHeaders && <RequirementTemplateBuilderHeaderRight blueprint={blueprint} />}
      <RequirementTemplateBuilderBodyRight blueprint={blueprint} />
    </Flex>
  );
};

RequirementTemplateRightBox.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default RequirementTemplateRightBox;
